import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import classnames from 'classnames';
import ownClasses from './feature-list.module.scss';
export interface Feature {
  uri?: string;
  label: string | undefined;
  value: string;
}
type FeatureProp = Omit<Feature, 'uri'>;
export interface FeatureListProps {
  features: FeatureProp[];
  singleColumn?: boolean;
}
export const FeatureList: FC<FeatureListProps> = t0 => {
  const $ = _c(5);
  const {
    features: t1,
    singleColumn: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const features = t3;
  const singleColumn = t2 === undefined ? false : t2;
  let t4;
  if ($[2] !== features || $[3] !== singleColumn) {
    t4 = features.length > 0 ? <ul className={classnames(ownClasses["feature-list"], {
      [ownClasses.list]: singleColumn,
      [ownClasses.columns]: !singleColumn
    })}>{features.map(_temp)}</ul> : null;
    $[2] = features;
    $[3] = singleColumn;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export const FeatureListItem: FC<FeatureProp> = t0 => {
  const $ = _c(10);
  const {
    label,
    value
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classnames(ownClasses.feature);
    t2 = classnames("caption book", ownClasses.label);
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <span className={t2}>{label}</span>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = classnames("caption book", ownClasses.value);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== value) {
    t5 = <span className={t4}>{value}</span>;
    $[5] = value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <li className={t1}>{t3}{t5}</li>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export default FeatureList;
function _temp(f) {
  return <FeatureListItem key={f.label} label={f.label} value={f.value} />;
}